<template>
    <div id="third-party-contract" class="vx-row no-gutter justify-center pl-4 pr-4">
        <div class="vx-row">
            <vx-card class="vx-col w-full black">
                <h5 class="mb-base text-center black">DESIGNACIÓN DE TERCERO AUTORIZADO</h5>
                <p class="text-justify">
                    Yo, <strong><u>{{ applicant }}</u></strong>, autorizo a mi 
                    promotor <strong><u>{{ supplier }}</u></strong> para que, en mi 
                    nombre y representación, lleve a cabo el trámite de apertura de cuenta como Solicitante en 
                    <strong>Red Girasol S.A.P.I. de C.V., Institución de Financiamiento Colectivo</strong>, y me apoye en la 
                    gestión de mi solicitud de crédito. 

                    <br><br>
                    Esta autorización permitirá:
                    <br>
                    <br>
                </p>

                <ol type="1" class="text-justify black ml-4 mb-base">
                    <li>
                       <b>  1. Enviar, actualizar o corregir</b> la información y documentación necesaria para la 
                        apertura de la cuenta y la evaluación de mi solicitud. 
                    </li>
                    <li>
                        <b>  2. Dar seguimiento al proceso</b> de solicitud de crédito, respondiendo a requerimientos 
                        de información adicional o aclaraciones por parte de RedGirasol. 
                    </li>
                    <li>
                        <b>  3. Recibir comunicaciones oficiales</b> relacionadas con mi solicitud, como 
                        notificaciones, confirmaciones o alertas, a través de correo electrónico u otros 
                        medios autorizados.
                    </li>
                </ol>

                <p class="text-justify">
                    Declaro que esta designación tiene como único fin facilitar y agilizar mi proceso de solicitud 
                    de financiamiento, y que en todo momento mantendré derecho de acceso y control sobre la 
                    información y decisiones relacionadas con mi trámite. 
                </p>
            </vx-card>
            <vx-card v-if="contract != null" class="vx-col w-full mt-4 black">
                <h3 class="primary mb-2">Tu firma</h3>
                <p class="my-2"><span class="bold">Nombre del documento: </span> {{ contract.type.name }}</p>
                <p class="my-2"><span class="bold">Versión del documento: </span> {{ contract.type.version }}</p>
                <p class="my-2"><span class="bold">Fecha de aceptación: </span> {{ signatureFormatDate(contract.created_at) }}</p>
                <p class="my-2"><span class="bold">Agente: </span> {{ metadata.agent }}</p>
                <p class="my-2"><span class="bold">IP: </span> {{ metadata.ip }}</p>
                <p class="my-2"><span class="bold">Método de aceptación: </span> {{ metadata.acceptance_method }}</p>
                <p class="my-2"><span class="bold">Correo electrónico: </span> {{ metadata.email }}</p>
                <h5 class="mt-5">Cadena de firma electrónica:</h5>
                <p class="text-break text-xs my-2">{{ signData.signature }}</p> 
            </vx-card>
        </div>
    </div>
</template>

<script>
import dateHelper from '@mixins/dateHelper';
export default {
    name: "ThirdPartyContract",
    mixins: [dateHelper],
    data: () => ({
        // TODO
    }),
    props: {
        applicant: String,
        supplier: String,
        contract: Object
    },
    computed: {
        signData() {
            if (this.contract != null) {
                return JSON.parse(this.contract.electronic_signature);
            }
            return null;
        },
        metadata() {
            if (this.contract != null) {
                return this.contract.electronic_signature_information.metadata;
            }
            return null;
        }
    }
}
</script>